export const SAV_ORDER = {
  contentTab: 'SAV_ORDER',
  label: 'Commandes SAV',
  filters: [
    {
      label: 'Type de contact',
      checkedItems: [],
      path: 'contact.store.contactType',
      staticName: 'contactType',
      defaultList: ['Professionnel', 'Marketplace', 'Particulier'],
    },
    {
      label: 'Status de commandes',
      checkedItems: [
        'RECORDED',
        'PENDING',
        'ERROR',
        'VALIDATED',
        'CANCELED_BY_CUSTOMER',
        'CANCELED_BY_SC',
        'SEND_TO_STO',
        'PREPARATION_CONFIRMED',
        'PREPARATION_STO_ENDED',
        'PAYMENT_PROCEED',
        'BEING_DELIVERED_TO_CUSTOMER',
        'TAV_DELIVERY_SUCCEED',
        'DELETED_BY_SC',
        'WAITING_SC',
      ],
      path: 'status',
      staticName: 'orderStatus',
      defaultList: [
        'RECORDED',
        'PENDING',
        'ERROR',
        'VALIDATED',
        'CANCELED_BY_CUSTOMER',
        'CANCELED_BY_SC',
        'SEND_TO_STO',
        'PREPARATION_CONFIRMED',
        'PREPARATION_STO_ENDED',
        'PAYMENT_PROCEED',
        'BEING_DELIVERED_TO_CUSTOMER',
        'TAV_DELIVERY_SUCCEED',
        'DELETED_BY_SC',
        'WAITING_SC',
      ],
    },
    {
      label: 'Marques',
      checkedItems: [],
      path: 'contact.store.brand',
      staticName: 'brand',
      defaultList: [
        'Casanoov',
        'Cazeboo',
        'Sicaan',
        'LeroyMerlin',
        'Bricoman',
        'Allegro',
        'ePrice',
        'Kaufland',
        'Worten',
        'Bricodepot',
        'Leclerc',
        'Home24',
        'But',
        'ManoMano',
        'Brico',
        'Praxis',
        'Castorama',
        'Hornbach',
        'Amazon',
      ],
    },
    {
      label: 'Magasins',
      checkedItems: [],
      path: 'contact.store',
      staticName: 'stores',
      defaultList: [],
    },
  ],
  query: {
    code: 'ORDER_SAV',
    path: 'type',
  },
  sortOptions: [
    {
      label: 'Date ↓',
      value: {
        createdAt: -1,
      },
    },
    {
      label: 'Date ↑',
      value: {
        createdAt: 1,
      },
    },
  ],
  table: [
    {
      label: 'Référence',
      code: 'REF',
      props: 'reference',
    },
    {
      label: 'Date de la commande',
      code: 'DATE',
      props: 'createdAt',
    },
    {
      label: 'Client',
      code: 'CONTACT',
      props: 'contact',
    },
    {
      label: 'Paiment',
      code: 'PRICE',
      props: 'price',
    },
    {
      label: 'Statut de la commande',
      code: 'STATUS',
      props: 'status',
    },
  ],
};
